export const SET_NAV_HEIGHT = 'setNavHeight'; // Dynamically setting the height of the navigation bar
export const SET_AGENT_DATA = 'setAgentData'; // Location of the status bar
export const SET_DISTANCE_FROM_TOP = 'setDistanceFromTop';
